import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Quote, PenLine, ArrowRight, MapPin } from "lucide-react";
import api, { API } from "../lib/api";
import { FadeIn } from "./motion";

// Homepage strip: up to three staff-featured beneficiary testimonials (approved only) with a "Share your story" link.
export const FeaturedTestimonials = () => {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/impact-testimonials", { params: { featured: true, limit: 3 } }).then((r) => setItems(r.data.items || [])).catch(() => {}); }, []);
  if (!items.length) return null;
  return (
    <section className="py-16 md:py-24 bg-[#155e3f] text-white" data-testid="home-testimonials">
      <div className="dk-container">
        <FadeIn>
          <div className="flex flex-wrap items-end justify-between gap-4 mb-10">
            <div>
              <p className="text-[11px] uppercase tracking-[0.3em] text-[#d6aa43] font-semibold">In their own words</p>
              <h2 className="font-serif text-3xl md:text-4xl font-bold mt-2">Beneficiary testimonials</h2>
            </div>
            <div className="flex gap-3">
              <Link to="/testimonials" className="dk-btn-outline !border-white/30 !text-white" data-testid="home-testimonials-all">All stories <ArrowRight size={14} /></Link>
              <Link to="/testimonials/share" className="dk-btn-primary" data-testid="home-testimonials-share"><PenLine size={14} /> Share your story</Link>
            </div>
          </div>
        </FadeIn>
        <div className="grid md:grid-cols-3 gap-6">
          {items.map((s, i) => {
            const photo = (s.media || []).find((m) => m.kind === "image");
            return (
              <FadeIn key={s.serial} delay={i * 0.08}>
                <article className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden h-full flex flex-col" data-testid={`home-testimonial-${s.serial}`}>
                  {photo && <img src={`${API.replace(/\/api$/, "")}${photo.url}`} alt={`${s.full_name} — beneficiary`} className="w-full h-52 object-cover" loading="lazy" />}
                  <div className="p-6 flex-1 flex flex-col">
                    <Quote size={22} className="text-[#d6aa43]" />
                    <p className="text-sm md:text-base text-white/85 mt-3 flex-1 line-clamp-6">{s.testimony}</p>
                    <footer className="mt-5 text-sm"><b>{s.full_name}</b>{s.location && <span className="text-white/90 inline-flex items-center gap-1 ml-2"><MapPin size={12} /> {s.location}</span>}</footer>
                  </div>
                </article>
              </FadeIn>
            );
          })}
        </div>
      </div>
    </section>
  );
};
